Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.FontStyle = module.exports.default = {
	BOLD: "bold",
	BOLD_ITALIC: "boldItalic",
	ITALIC: "italic",
	REGULAR: "regular"
};